const ITEMS = [
  "Science-Informed Method",
  "40+ Tea Recipes",
  "30-Day Sustainable Routine",
  "Zero Crash Diets",
  "7-Day Gentle Reset",
  "Mindful Daily Rituals",
];

export default function Marquee() {
  const row = [...ITEMS, ...ITEMS];
  return (
    <div className="bg-[#1C3A27] py-5 overflow-hidden border-y border-[#D4A359]/25" data-testid="marquee-banner">
      <div className="marquee-track flex w-max items-center">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center" aria-hidden={half === 1}>
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-display text-lg sm:text-xl font-semibold text-[#FAF7F2]/90 tracking-wide px-6 whitespace-nowrap">
                  {item}
                </span>
                <svg viewBox="0 0 24 24" className="w-4 h-4 fill-[#D4A359] shrink-0">
                  <path d="M12 2c3 4 3 8 0 12-3-4-3-8 0-12zm0 20c-3-4-3-8 0-12 3 4 3 8 0 12z" />
                </svg>
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
}
